module.exports = __webpack_public_path__ + "img/account_credit.ef373c6f.svg";